import React, { useEffect, useState } from "react";
import axios from "axios";
import { base_url } from "../../context/Authcontext";

// ✅ Define defaultColors separately
const defaultColors = {
  "--dark-theme-color": "#fff",
  "--dark-theme-color-navbar": "#ffffff",
  "--dark-theme-data-color": "#023448",
  "--dark-theme-data-border": "#efeded",
  "--dark-theme-data-box": "#72bbef",
  "--dark-theme-data-homebet": "#beddf4",
  "--dark-theme-data-homebet2": "#f3dce2",
  "--dark-theme-data-backbtn": "#0A6E8A",
  "--dark-theme-data-set": "linear-gradient(#61cce6, #29a3c2)",
  "--dark-theme-data-set2": "linear-gradient(#fbbcbf,#eb7c81)",
  "--dark-theme-data-min": "#166534",
  "--dark-theme-data-stake": "#7e22ce",
  "--dark-theme-data-clear": "#991b1b",
  "--dark-theme-data-cancel": "linear-gradient(#ff5071, #c30529)",
  "--dark-theme-data-submit": "linear-gradient(#07af07, #026d02)",
  "--dark-theme-data-box2": "#faa9ba",
  "--dark-theme-data-box3": "#72bbef7f",
  "--dark-theme-sidebar-hovers": "#7fc5e0",
  "--dark-theme-data-bg": "#ffffff",
  "--dark-theme-card-bg-light": "#222c3b",
  "--dark-theme-card-bg-light-gradiant": "#19233c",
  "--dark-theme-card-bg-light2": "#a4a4a4",
  "--dark-theme-white-color": "#000000",
  "--dark-theme-bg": "linear-gradient(#000101, #029aaa)",
  "--dark-theme-demoaccount": "#ff0000",
  "--dark-theme-card-bg": "linear-gradient(#5ecbdd, #146578)",
  "--dark-theme-button-special": "linear-gradient(#5ecbdd, #146578)",
  "--dark-theme-dark-blue-variant": "#005762",
  "--dark-theme-dark-blue-bm": "#3454bf",
  "--dark-theme-time-remaining": "#42afdb",
  "--bg-btn": "#5ecbdd",
  "--text-color": "#ffffff",
  "--report-cate-item-border-clr": "#ffe500",



  "--bg-primary": "#08c",
  "--text-primary": "#fff",
  "--bg-primary-hover": "#08c",
  "--input-border": '#dbdbdb',
  "--text-body": "#000000",
  "--bg-table": "#f7f7f7",
  "--text-table": "#333",
  "--bg-secondary": "#02AABB",
  "--text-secondary": "#fff",
  "--bg-table-row": "#f2f2f2",
  "--bg-sidebar": "#cccccc",
  "--table-border" : "#c7c8ca",
  "--bg-secondary85" : "#02AABBD9",
  "--text-info" : "#097c93",
  "--bg-sidebar" : "#cccccc",
  "--text-sidebar": "#000000",
  "--bg-info": "#097c93",
  "--bg-danger": "#bd1828",
  "--bg-success": "#086f3f",
};

// ✅ Static text labels for color meanings
const colorDetails = {
  "--dark-theme-color": "website background color,",
  "--dark-theme-color-navbar": "Navbar text-color, offcanvas text-color, topbar both button and userName text-color, footer bottom text-color, match(type) heading text-color, topbar (icon & text-color) footer text-color in FrontPage, withdraw page text-color, CricketBet page & FootBAllBat, Tennis, and cricket page text-color, Login-form input background, deposite & withdraw page background",
  "--dark-theme-data-color": "Data (today and time) text-color, sidebar text-color",
  "--dark-theme-data-border": "Border color data boxes & Sidebar boxes",
  "--dark-theme-data-box": "Primary databox background color, login form border-color & some text-color, offcanvas deposite & withdraw button background-color, CricketBet & FootBAllBat & Tennis page heading background",
  "--dark-theme-data-homebet": "Website Bet box1 background-color",
  "--dark-theme-data-homebet2": "Website bet box2 Bet background-color",
  "--dark-theme-data-backbtn": "Website bet box1 Back button background-color",
  "--dark-theme-data-set": "Website Bet box1 Settings button background-color, withdraw page",
  "--dark-theme-data-set2": "Website Bet box2 Settings button background-color",
  "--dark-theme-data-min": "Website Bet box Min stake background-color",
  "--dark-theme-data-stake": "Website Bet box edit Stake background-color",
  "--dark-theme-data-clear": "Website Bet box Clear button background-color",
  "--dark-theme-data-cancel": "Website Bet box Cancel button background-color",
  "--dark-theme-data-submit": "Website Bet box Submit button background-color",
  "--dark-theme-data-box2": "Website Primary databox background color",
  "--dark-theme-data-box3": "Box tertiary, CricketBet page, FootBAllBat page, Tennis page pink box background",
  "--dark-theme-sidebar-hovers": "Sidebar hover effect background-color",
  "--dark-theme-data-bg": "Data background, sidebar background, login & demo button text-color, login form background, WEBSITE background",
  "--dark-theme-card-bg-light": "casinoGames Page gameName heading & tabs background",
  "--dark-theme-card-bg-light-gradiant": "data bet box text-color",
  "--dark-theme-card-bg-light2": "matches bet minus & plus button background",
  "--dark-theme-white-color": "horse-racing text-color, matches between text-color, Login form some text-color, register form text-color, sports_bets page text-color, change password form text-color, withdraw & deposite page text-color and background, CricketBet page, FootBAllBat page, Tennis page, login form input text-color",
  "--dark-theme-bg": "CricketBet page FootBAllBat page, Tennis page background gradient,",
  "--dark-theme-demoaccount": "Demo account background, livecount background, live text-color",
  "--dark-theme-card-bg": "CricketBet page background gradient, sports_bets page gradient button, FootBAllBat page, Tennis page",
  "--dark-theme-button-special": "Special buttons, withdraw page button background, ",
  "--dark-theme-dark-blue-variant": "Navbar background, sports_bets page thead background, offcanvas background, Topbar & Footer in frontpage, register eye icon background",
  "--dark-theme-dark-blue-bm": "Matches data Max button",
  "--dark-theme-time-remaining": "sidebar popular background, matches heading background, Offcanvas both button background color",
  "--bg-btn": "Navbar Active item Button background",
  "--text-color": "sidebar hover text-color",
  "--report-cate-item-border-clr": ""
};


const ColorSettings = () => {
  const [colors, setColors] = useState(defaultColors);

  useEffect(() => {
    // Apply cached theme immediately if available
    const localTheme = localStorage.getItem("theme-colors");
    if (localTheme) {
      try {
        const parsed = JSON.parse(localTheme);
        const merged = { ...defaultColors, ...parsed };
        setColors(merged);
        applyTheme(merged);
      } catch (e) {
        console.error("Invalid local theme data");
      }
    }

    // Fetch theme from backend
    const fetchTheme = async () => {
      try {
        const res = await axios.get(`${base_url}/get`);
        const stored = res.data.theme || {};
        const merged = { ...defaultColors, ...stored };
        setColors(merged);
        applyTheme(merged);
      } catch (err) {
        console.error("Failed to fetch theme:", err);
      }
    };

    fetchTheme();
  }, []);

  const applyTheme = (theme) => {
    Object.entries(theme).forEach(([key, value]) => {
      document.documentElement.style.setProperty(key, value);
    });
  };

  const handleColorChange = (variable, value) => {
    const updated = { ...colors, [variable]: value };
    setColors(updated);
    applyTheme(updated);
  };

  const saveTheme = async () => {
    try {
      // Save to backend
      await axios.post(`${base_url}/save`, { themes: colors });

      // Save to localStorage
      localStorage.setItem("theme-colors", JSON.stringify(colors));

      alert("Theme saved!");
    } catch (err) {
      console.error("Theme save error:", err);
      alert("Failed to save theme.");
    }
  };

  const resetTheme = () => {
    setColors(defaultColors);
    applyTheme(defaultColors);
    localStorage.removeItem("theme-colors");
  };


  return (
    <>
      <div className="p-4">
        <h4 className="mb-3 text-dark">Customize Theme</h4>
        {Object.entries(colors).map(([key, value]) => (
          <div key={key} className="mb-2 d-flex align-items-center">
            <label style={{ width: 230 }}>{key}</label>

            {key === '--dark-theme-bg' || key === '--dark-theme-data-submit' || key === '--dark-theme-data-cancel' || key === '--dark-theme-data-set' || key === '--dark-theme-data-set2' || key === '--dark-theme-card-bg' || key === '--dark-theme-button-special' ? (
              <>
                <input
                  type="text"
                  value={value}
                  onChange={(e) => handleColorChange(key, e.target.value)}
                  placeholder="Enter gradient (e.g. linear-gradient(...))"
                  className="form-control"
                  style={{ width: '250px' }}
                />
                <span className="ms-2 text-muted" style={{ fontSize: '0.85rem' }}>
                  {colorDetails[key] ? colorDetails[key] : `Missing description for ${key}`}
                </span>

              </>
            ) : (
              <>
                <input
                  type="color"
                  value={value}
                  onChange={(e) => handleColorChange(key, e.target.value)}
                />
                <span className="ms-2 text-muted" style={{ fontSize: '0.85rem' }}>
                  {colorDetails[key] ? colorDetails[key] : `Missing description for ${key}`}
                </span>

              </>
            )}
          </div>
        ))}


        <button className="btn btn-primary mt-3" onClick={saveTheme}>
          Save Theme
        </button>
        <button className="btn btn-danger ms-3 mt-3" onClick={resetTheme}>
          Reset Theme
        </button>
      </div>
    </>
  );
};

export default ColorSettings;
